import { Component, OnInit } from '@angular/core';
import { CoreApiService } from '../services/core-api.service';
import { QuoteSummary } from '../models/quote-summary';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';

@Component({
  selector: 'breadcrumb-header',
  templateUrl: './breadcrumb-header.component.html',
  styleUrls: ['./breadcrumb-header.component.scss']
})
export class BreadcrumbHeaderComponent implements OnInit {

  public quoteSummary: QuoteSummary;
  public quoteid: number;
  public companyName: string;
  
  constructor(private api: CoreApiService,
      private route: ActivatedRoute,
      private toast: MatSnackBar) {  }

  openSnackBar() {
      this.toast.openFromComponent(SnackBarComponent, {
          duration: 4000,
          horizontalPosition: 'left',
          verticalPosition: 'bottom',

      });
  }

    ngOnInit() {
        this.quoteid = this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']);
        this.api.getQuoteSummary(this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']), this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId'])).subscribe(qs => {
                if (qs) {
                    this.quoteSummary = qs;
                } else {
                    console.error('Invalid Quote ID and no quote summary information returned');
                    }
            });
  }

}
